// extracted by mini-css-extract-plugin
export default {"container":"jV0uFfZ","menuItem":"HtlMfll jFyrDfG w3QwoQC","label":"dni2mQM","label__sale":"vQD86li","image":"ZVNhIet"};